import React from "react";

export default function About() {
  return (
    <section className='about'>
      <div>
      <h2>About</h2>
        <p>
          We know how is hard to find healthy options when you are not cooking
          yourself. Even rarer to find a full dedicated restaurant that will
          have most dietary restrictions. Allow me to introduce you <i>Foodora</i>.
          It was created to make your life easier since we are the ones
          looking for healthy dishes for you. That way, you can spend your day
          not stressing if you have to go out with friends, debating if you
          should or should not accept their invite because they are choosing a
          place that has nothing you can choose from according to your dietary
          restrictions.
        </p>
        <p>
          Our app includes several dietary restriction that goes from peanut
          allergy, keto, low carb, sugar free, vegan and so much more! No matter
          your goal, if it is from allergy or diet, we have the dishes ready
          for you to savor!
        </p>
      </div>
    </section>
  );
}
